import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

// export const UserInfo = atom({
//   key: "User", // unique ID (with respect to other atoms/selectors)
//   default: null,
//   effects_UNSTABLE: [persistAtom],
//   // default value (aka initial value)
// });
// Keep the session in this tab only. Never persist shipping details or passwords.
const sessionKey = "technogenious-session";
function readSession() {
  try {
    localStorage.removeItem("User");
    const saved = JSON.parse(sessionStorage.getItem(sessionKey) || "null");
    if (saved?.expiresAt > Date.now()) return saved.value;
    sessionStorage.removeItem(sessionKey);
  } catch { /* Storage may be unavailable or malformed. */ }
  return null;
}
export const UserInfo = atom<any>({
  key: "User",
  default: readSession(),
  effects_UNSTABLE: [({onSet}) => {
    onSet(value => {
      try {
        if (!value?.access_token) { sessionStorage.removeItem(sessionKey); return; }
        const safe = {access_token:value.access_token,user:{_id:value.user?._id,fullName:value.user?.fullName,email:value.user?.email}};
        const claims = JSON.parse(atob(value.access_token.split('.')[1].replace(/-/g,'+').replace(/_/g,'/')));
        sessionStorage.setItem(sessionKey,JSON.stringify({expiresAt:claims.exp*1000,value:safe}));
      } catch { sessionStorage.removeItem(sessionKey); }
    });
  }],
});
export const FilterInfo = atom({
  key: "Filters", // unique ID (with respect to other atoms/selectors)
  default: null,

  // default value (aka initial value)
});

export const FilterCheckBox = atom({
  key: "Filters-checkbox", // unique ID (with respect to other atoms/selectors)
  default: null,

  // default value (aka initial value)
});
export const searchValue = atom({
  key: "search-value", // unique ID (with respect to other atoms/selectors)
  default: null,

  // default value (aka initial value)
});

export const MinFilterSlider = atom({
  key: "Filters-min-slider", // unique ID (with respect to other atoms/selectors)
  default: null,

  // default value (aka initial value)
});

export const MaxFilterSlider = atom({
  key: "Filters-max-slider", // unique ID (with respect to other atoms/selectors)
  default: null,

  // default value (aka initial value)
});

export const cartItems = atom({
  key: "Cart-items",
  default: [],
  effects_UNSTABLE: [persistAtom],
});


const TEN_MINUTES = 6 * 60 * 1000; // 10 minutes in milliseconds

const persistAtomWithExpiry = ({ key, default: defaultValue }) => {
  const persistedValue = localStorage.getItem(key);
  const initial =
    persistedValue != null ? JSON.parse(persistedValue) : defaultValue;

  const atomState = atom({
    key,
    default: initial,
    effects_UNSTABLE: [
      ({ onSet }) => {
        onSet((newValue) => {
          localStorage.setItem(key, JSON.stringify(newValue));
        });
      },
    ],
  });

  setTimeout(() => {
    localStorage.removeItem(key);
  }, TEN_MINUTES);

  return atomState;
};


export const DataId = persistAtomWithExpiry({
  key: "data-id",
  default: [],
  // effects_UNSTABLE: [persistAtom],
});
